<template>
    <div class="column fit">
        <div v-if="slots.banner" class="col-auto q-mx-sm q-mt-sm">
            <slot name="banner" />
        </div>
        <div v-if="slots.count || total" class="col-auto q-px-md q-pt-sm slot-count">
            <template v-if="slots.count">
                <slot name="count" />
            </template>
            <template v-else>
                {{ countText }}
            </template>
        </div>
        <slot name="content" />
        <div class="col-auto">
            <div v-show="!noChildren" class="row" style="min-height: 60px">
                <div class="col">
                    <MutationObserverDiv @on-change="onMutation" class="bg-white" style="height: 60px; bottom: 0">
                        <slot name="panel" />
                    </MutationObserverDiv>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, useSlots } from "vue";
import MutationObserverDiv from "@/shared/components/mutation-observer/mutation-observer-div.vue";
import { Total } from "@/shared/search/search.types.ts";
import { generateSearchHitsText } from "@/shared/utils/total-formatter.ts";

const props = defineProps<{ total?: Total }>();

const noChildren = ref(true);

const slots = useSlots();

const onMutation = (children: HTMLCollection) => {
    noChildren.value = children.length === 0;
};

const countText = computed(() => {
    return props.total ? generateSearchHitsText(props.total) : "";
});
</script>
